import styled, { css } from "styled-components";
import { lighten, readableColor } from 'polished';
import { Alert, Box, Button, Col, Row } from "@intech/web-ui";
import { device } from "../../../device";

export const GrayBox = styled(Box)`
  color: #7c7e80;
`;

export const Title = styled.h3`
  margin: 10px;
  color: #7c7e80;
`;

export const WrapRow = styled(Row)`
  flex-wrap: wrap;
  align-items: baseline;
`;

export const ToggleBox = styled.div`
  display: flex;
  align-items: center;
`;

export const Checkbox = styled.input`
  margin-right: 10px;
`;

export const Alertanifesto = styled(Alert)`
  margin-bottom: 5px;
`;

export const AutoColumn = styled(Col)`
  width: 100%;
  display: flex;
  @media ${device.tablet} {
    flex-direction: row;
  }
  @media not ${device.tablet} {
    flex-direction: column;
  }
`;

export const Label = styled.div`
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
  @media ${device.tablet} {
    flex: 1 0 40%;
    max-width: 40%;
    text-align: right;
  }
  @media not ${device.tablet} {
    flex: 1 0 100%;
    max-width: 100%;
    text-align: left;
  }
  position: relative;
  width: 100%;
  padding: calc(0.375rem + 1px) 15px;
`;